import "../../App.css";
import Api from "../api/api";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import showToast from "../util/toast";
import CodeForm from "../CodeForm/CodeForm";

const AddCode = () => {
  const history = useHistory();
  const onSubmit = (params) => {
    Api.addCode({
      params,
      onError: (error) => {
        showToast("error", JSON.stringify(error));
      },
      onSuccess: () => {
        showToast("success", "Code is successfully added");
        history.goBack();
      },
    });
  };

  return <CodeForm onSubmit={onSubmit} />;
};

export default AddCode;
